export default "/assets/images/app-update-img-03.b9b0ea463d4fceee.webp";